import { IDataHandler } from '../IDataHandler';
import { QuestDataSet } from '../DataSet/Quest';
import { QuestEventName } from '../TrackingEvent';
import { allTrackingEvents } from '../TrackingEvent';

type questDataKey = keyof QuestDataSet;
//
export const questStartDataMap: Map<
    allTrackingEvents,
    questDataKey[]
> = new Map<allTrackingEvents, questDataKey[]>([
    [
        QuestEventName.questStart,
        ['qQuestName', 'qQuestID', 'qQuestTier'],
    ],
]);

export class QuestDataHandler implements IDataHandler<QuestDataSet> {
    public data: QuestDataSet = {
        ...new QuestDataSet(),
    };

    public getEventData(eventName: QuestEventName): QuestDataSet {
        const data = questStartDataMap.get(eventName).reduce((acc, key) => {
            acc[key] = this.data[key] as never;
            return acc;
        }, {} as QuestDataSet);

        if (eventName === QuestEventName.questStart) {
            this.data = new QuestDataSet();
        }
        return data;
    }

    public clearData(): void {
        this.data = {
            ...new QuestDataSet(),
        };
    }
}
